module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"base":{"emptystate":{"notifications":{"buttons":{"edit_interests":"Edit Interests","event":{"to_events":"To Events"},"portfolio":{"create_portfolio":"Create Portfolio","depot_upload":"Depot Upload"},"product":{"ranking":"To Fund Ranking","search":"To Fund Search"},"profile":{"edit":"Edit Profile","settings":"Adjust Settings"}}}}}}}}}')
  delete Component.options._Ctor
}
